import { useContext } from 'react';
import { TypedOpenApiContext } from './TypedOpenApiProvider';

export function useTypedOpenApi() {
  const contextValue = useContext(TypedOpenApiContext);

  if (!contextValue) {
    throw new Error('Wrap your components tree with a TypedOpenApiProvider component');
  }

  return contextValue;
}
